import { render, staticRenderFns } from "./VerticalNavMenuCRM.vue?vue&type=template&id=e8e6805a"
import script from "./VerticalNavMenuCRM.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuCRM.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuCRM.vue?vue&type=style&index=0&id=e8e6805a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports